/*@ngInject*/
const ChecklistMediator = function (getChecklistItemsRepository, updateChecklistItemRepository) {

    this.getChecklistItems = function (submissionId) {
        return getChecklistItemsRepository.getChecklistItems(submissionId);
    };

    this.updateChecklistItem = function (checklistItemId, checked, comment) {
        return updateChecklistItemRepository.updateChecklistItem(checklistItemId, checked, comment);
    };

};

angular.module('gw-um-submission').service('checklistMediator', ChecklistMediator);
